// 格式化【获取同类】响应
export const formatFindSimilarUsersResponse = (data: any) => {
  const keywords = data?.keywords || [];
  const users = data?.users || [];
  const count = data?.count || 0;
  let userList = '';
  if (users && users.length > 0) {
    userList = users
      .slice(0, 10)
      .map(
        (u: any, idx: number) =>
          `${idx + 1}. **${u.nickname || '未知'}** - 粉丝${u.follower_count || 0} - ${u.signature?.substring(0, 30) || ''}`
      )
      .join('\n');
  }

  return `### 👥 同类账号搜索完成

**搜索关键词：** ${keywords?.join('、') || '无'}

**找到 ${count || 0} 个同类账号：**

${userList || '暂无数据'}

${users.length > 10 ? `\n*还有 ${users.length - 10} 个账号未显示*\n` : ''}
**提示：** 这些账号已保存，可以使用"同类热门"查看他们的热门视频`;
};

// 格式化【同类热门】响应
export const formatSimilarUsersHotResponse = (data: any) => {
  const users = data?.users || [];
  const hotVideos = data?.hotVideos || [];
  let videosList = '';
  if (hotVideos && hotVideos.length > 0) {
    videosList = hotVideos
      .map((item: any) => {
        const userVideos = item.videos
          ? (Array.isArray(item.videos) ? item.videos : [item.videos]).slice(0, 3)
          : [];
        const videosText = userVideos
          .map(
            (v: any, idx: number) => {
              const shareUrl = v.share_url || `https://www.douyin.com/video/${v.aweme_id || ''}`;
              return `   ${idx + 1}. ${v.title || v.desc || '无标题'} 👍${v.digg_count || 0}  [打开视频](${shareUrl})`;
            }
          )
          .join('\n');
        return `**@${item.user?.nickname || '未知用户'}** (${item.user?.follower_count || 0}粉丝)：\n${videosText || '   暂无视频数据'}`;
      })
      .join('\n\n');
  }

  return `### 🔥 同类账号热门视频

**已分析 ${users?.length || 0} 个同类账号**

${videosList || '暂无数据'}

---
**提示：** 可以复制这些视频的链接进行"评论提炼"，挖掘潜在客户`;
};

// 格式化【评论提炼】响应
export const formatExtractLeadsResponse = (data: any) => {
  const allComments = data?.allComments || data?.leads || [];
  const comments = data?.displayComments || allComments;
  const summary = data?.summary || '';
  const leadCount = allComments.filter((c: any) => c.is_lead).length;

  let commentsList = '';
  if (comments.length > 0) {
    commentsList = comments
      .slice(0, 10)
      .map((c: any, idx: number) => {
        const emoji = c.is_lead ? '🔴' : '⚪';
        const userName = c.nickname || c.username || '匿名';
        const profileLink = c.profile_url || (c.sec_uid ? `https://www.douyin.com/user/${c.sec_uid}` : '');
        const userPart = profileLink ? `[@${userName}](${profileLink})` : `@${userName}`;
        const cid = c.comment_id || 'N/A';
        const leadMark = c.is_lead ? ` [${c.type || '潜在客户'}]` : '';
        return `${idx + 1}. ${emoji} ${userPart} \`ID:${cid}\`${leadMark}\n   > ${c.content?.substring(0, 60) || '无内容'}...`;
      })
      .join('\n\n');

    if (leadCount > 0) {
      commentsList = `**🎯 潜在客户 ${leadCount} 条**\n\n${commentsList}`;
    }
  }

  return `### 💎 评论提炼完成

**共 ${allComments.length} 条评论，${leadCount} 条潜在客户**

${summary ? `**分析总结：** ${summary}\n` : ''}
${commentsList || '暂无数据'}

${comments.length > 10 ? `\n*还有 ${comments.length - 10} 条评论未显示*\n` : ''}
---
**提示：** 点击"评论分析"对潜在客户进行深度意向分析并获取回复建议`;
};

// 格式化【评论分析】响应
export const formatAnalyzeLeadsResponse = (data: any) => {
  const analysis = data?.analysis;
  const detailedAnalysis = data?.detailedAnalysis;
  const strategy = data?.strategy;
  const comment = data?.comment;
  const replies = data?.replies;
  const reply = data?.reply;

  // 新版单条评论分析
  if (comment || reply) {
    let content = `### 📊 评论分析结果\n\n`;
    content += `**目标评论**\n`;
    content += `\n> 💬 ${comment?.content || '无内容'}\n\n`;
    content += `👍 ${comment?.digg_count || 0}  ·  💬 ${replies?.length || 0} 条回复\n\n`;

    content += `**分析结论**\n`;
    content += `• 情感倾向：${analysis?.sentiment === 'positive' ? '正面 😊' : analysis?.sentiment === 'negative' ? '负面 😤' : '中性 😐'}\n`;
    content += `• 用户意图：${analysis?.intent || '未知'}\n`;
    if (analysis?.key_points?.length) {
      content += `• 关键要点：${analysis.key_points.join('、')}\n`;
    }
    if (analysis?.user_profile) {
      content += `• 用户画像：${analysis.user_profile}\n`;
    }
    content += '\n';

    if (replies?.length > 0) {
      content += `**回复汇总**（共 ${replies.length} 条）\n`;
      content += replies
        .slice(0, 5)
        .map(
          (r: any, idx: number) =>
            `${idx + 1}. ${r.content?.substring(0, 50) || ''}${r.content?.length > 50 ? '...' : ''}`
        )
        .join('\n');
      if (replies.length > 5) content += `\n...还有 ${replies.length - 5} 条回复`;
      content += '\n\n';
    }

    content += `**AI 回复建议**\n`;
    content += `> ${reply?.content || '暂无建议'}\n\n`;
    content += `💡 策略：${reply?.strategy || '直接回复'}  ·  语气：${reply?.tone || '友好'}`;

    return content;
  }

  // 旧版批量 leads 分析（兼容）
  let analysisList = '';
  if (detailedAnalysis && detailedAnalysis.length > 0) {
    analysisList = detailedAnalysis
      .slice(0, 5)
      .map((a: any, idx: number) => {
        const emoji =
          a.conversion_potential === 'high' ? '🟢' : a.conversion_potential === 'medium' ? '🟡' : '🔴';
        return `${idx + 1}. ${emoji} **@${a.username || '匿名'}** (意向分: ${a.intent_score || 0}/100)\n   - 意图：${a.sentiment || '未知'} | 痛点：${a.pain_points?.join(', ') || '无'}\n   - 💬 建议回复：${a.suggested_reply?.substring(0, 60) || '无'}...`;
      })
      .join('\n\n');
  }

  const stats = analysis
    ? `
**数据统计：**
- 总线索数：${analysis.total_leads || 0}
- 高意向：${analysis.high_priority || 0} | 中意向：${analysis.medium_priority || 0} | 低意向：${analysis.low_priority || 0}
    `
    : '';

  return `### 📊 客户意向分析完成

${stats}

**详细分析：**

${analysisList || '暂无数据'}

${detailedAnalysis?.length > 5 ? `\n*还有 ${detailedAnalysis.length - 5} 条分析未显示*\n` : ''}
---
**整体跟进策略：**
${strategy || '暂无策略建议'}

**提示：** 可以复制建议回复内容，直接回复给对应客户`;
};
